import { StatePreV7, StateV7 } from './7_migrate_assekuranztarif.interface';

export const migrateAssekuranztarif = (previousState: StatePreV7, newVersion: number): StateV7 => {
  const newState = {
    ...previousState,
    version: newVersion,
    vorvertragHinweis: {
      ...previousState.vorvertragHinweis,
      assekuranztarifChanged: previousState.vorvertragHinweis?.finanzdienstleistertarifChanged,
    },
  };
  delete newState.vorvertragHinweis.finanzdienstleistertarifChanged;
  return newState;
};
